import { Navigate, Outlet } from "react-router-dom";
import { MASTER_TOKEN_KEY } from "../services/masterApi";

const MasterUserRoute = () => {
  const masterToken = localStorage.getItem(MASTER_TOKEN_KEY);
  const isMasterUser =
    !!masterToken && localStorage.getItem("userType") === "MASTER_USER";

  if (!isMasterUser) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default MasterUserRoute;
